export default __webpack_public_path__ + "static/media/faces.41106bf4.png";